import { faFileLines, faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { InfoTooltip } from '@karnov/kui-react'

import { useTranslation } from 'services/i18n'

import type { FC, PropsWithChildren } from 'react'

export const KfcContentWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation()
  return (
    <div className="kfc-container relative mt-4 rounded-2xl border-2 border-inverse bg-default p-4 lg:mt-8 lg:p-7">
      <div className="absolute right-5 top-5">
        <div className="group relative flex items-center">
          <InfoTooltip
            content={t('kfc.description')}
            side="left"
          >
            <FontAwesomeIcon icon={faInfoCircle} />
          </InfoTooltip>
        </div>
      </div>
      <div className="mb-2 flex size-9 items-center justify-center rounded-lg bg-inverse lg:float-left lg:mb-0 lg:mr-5">
        <FontAwesomeIcon
          className="text-default-inverse"
          size="lg"
          icon={faFileLines}
        />
      </div>
      <div className="flex min-h-full items-center">{children}</div>
    </div>
  )
}
